export const SDK_VERSION = "2.18.0";
